import * as yup from 'yup'

type VolumeTier = {
  upTo?: number | null
  unitAmount?: number
  flatAmount?: number | null
}

export default function validateVolumeTiers(tiers?: VolumeTier[]) {
  if (!tiers || tiers.length === 0) return true

  for (let i = 0; i < tiers.length; i++) {
    const tier = tiers[i]
    if (!tier) continue

    const isLastTier = i === tiers.length - 1

    if (tier.upTo === null || tier.upTo === undefined) {
      if (!isLastTier) {
        return false
      }
    } else {
      if (i > 0) {
        const prevTier = tiers[i - 1]
        if (prevTier && prevTier.upTo !== null && prevTier.upTo !== undefined) {
          if (tier.upTo <= prevTier.upTo) {
            return false
          }
        }
      }
    }
  }

  return true
}

declare module 'yup' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface ArraySchema<TIn, TContext, TDefault, TFlags> {
    /**
     * Validates that volume tiers have monotonically increasing `upTo` values
     * and that only the last tier can be unlimited (upTo: null).
     * @param message - The error message to display if validation fails
     */
    validVolumeTiers(message: string): this
  }
}

yup.addMethod(yup.array, 'validVolumeTiers', function (message: string) {
  return this.test('validateVolumeTiers', message, validateVolumeTiers)
})

export {}
